import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ProjectService } from '../Services/project.service';



@Injectable()
export class ProjectResolver implements Resolve<any> {
  constructor(private project: ProjectService) {}

  resolve() {
    return this.project.getItems();
  }
}